import type { NavSectionProps } from 'src/components/nav-section';

import { paths } from 'src/routes/paths';

import { CONFIG } from 'src/global-config';

import { Iconify } from 'src/components/iconify';
import { SvgColor } from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`${CONFIG.assetsDir}/assets/icons/navbar/${name}.svg`} />
);

const ICONS = {
  banking: icon('ic-banking'),
  order: icon('ic-order'),
  product: icon('ic-product'),
  tour: icon('ic-tour'),
  mail: icon('ic-mail'),
  user: icon('ic-user'),
  params: icon('ic-params'),
  usersGroup: icon('ic-users-group'),
  store: icon('ic-store'),
  analytics: icon('ic-analytics'),
  bill: icon('ic-bill'),
  bill2: icon('ic-bill2'),
  deposit: icon('ic-deposit'),
  refund: icon('ic-refund'),
  income: icon('ic-income'),
  lock: icon('ic-lock'),
  notebook: icon('ic-notebook'),
  share: icon('ic-share'),
  userGroup: icon('ic-users-group'),
  userRole: icon('ic-user-role'),
};

// ----------------------------------------------------------------------

/** 趣享租后台侧边栏菜单 */
export const navData: NavSectionProps['data'] = [
  {
    subheader: '业务',
    items: [
      {
        title: '订单管理',
        path: paths.dashboard.business.orders.root,
        icon: ICONS.order,
        children: [
          {
            title: '租赁订单',
            path: paths.dashboard.business.orders.rent,
          },
        ],
      },
      {
        title: '逾期管理',
        path: paths.dashboard.business.overdue,
        icon: <Iconify icon="solar:danger-triangle-bold-duotone" />,
      },
      {
        title: '商品管理',
        path: paths.dashboard.business.products.root,
        icon: ICONS.product,
        children: [
          {
            title: '商品列表',
            path: paths.dashboard.business.products.list,
          },
          {
            title: '创建商品',
            path: paths.dashboard.business.products.create,
          },
          {
            title: '商品类目',
            path: paths.dashboard.business.products.category,
          },
        ],
      },
      {
        title: '资产管理',
        path: paths.dashboard.business.assets.root,
        icon: <Iconify icon="solar:box-bold-duotone" />,
        children: [
          {
            title: '资产列表',
            path: paths.dashboard.business.assets.list,
          },
          {
            title: '调拨记录',
            path: paths.dashboard.business.assets.transfers,
          },
          {
            title: '删除记录',
            path: paths.dashboard.business.assets.deletedRecords,
          },
          {
            title: '资产类目',
            path: paths.dashboard.business.assets.categories,
          },
        ],
      },
      {
        title: '门店管理',
        path: paths.dashboard.business.stores.root,
        icon: ICONS.store,
      },
    ],
  },
  {
    subheader: '会员管理',
    items: [
      {
        title: '会员列表',
        path: paths.dashboard.members.list,
        icon: ICONS.user,
      },
    ],
  },
  {
    subheader: '财务管理',
    items: [
      { title: '财务概览', path: paths.dashboard.finance.overview, icon: ICONS.analytics },
      { title: '租金账单', path: paths.dashboard.finance.bills, icon: ICONS.bill },
      { title: '押金管理', path: paths.dashboard.finance.deposits, icon: ICONS.deposit },
      { title: '收款流水', path: paths.dashboard.finance.payments, icon: ICONS.bill2 },
      { title: '退款记录', path: paths.dashboard.finance.refunds, icon: ICONS.refund },
      { title: '资金结算', path: paths.dashboard.finance.settlements, icon: ICONS.banking },
      {
        title: '分账参与方',
        path: paths.dashboard.finance.participants,
        icon: <Iconify icon="solar:users-group-rounded-bold" />,
      },
      { title: '清分规则', path: paths.dashboard.finance.clearingRules, icon: ICONS.share },
    ],
  },
  {
    subheader: '组织管理',
    items: [
      {
        title: '员工管理',
        path: paths.dashboard.organization.users,
        icon: ICONS.usersGroup,
      },
      {
        title: '角色管理',
        path: paths.dashboard.organization.roles,
        icon: ICONS.lock,
      },
    ],
  },
  {
    subheader: '系统管理',
    items: [
      {
        title: '系统设置', // 租户信息管理
        path: paths.dashboard.system.settings,
        icon: <Iconify icon="solar:settings-bold-duotone" />,
      },
    ],
  },
];
